import { observer } from 'mobx-react-lite'
import React from 'react'
import cx from 'classnames'

interface Props {
  label: string
  description: string
  value: number
  max: number
}

const Progress = observer(({ label, description, value, max }: Props) => {
  const progress = Math.min((value / max) * 100, 100)
  return (
    <div className={cx('progress', { 'is-full': progress === 100 })}>
      <span className="progress-label">{label}</span>
      <div className="progress-bar-container">
        <div
          className="progress-bar"
          style={
            {
              '--progress-value': `${progress}%`,
            } as React.CSSProperties
          }
        />
        <span className="progress-description">{description}</span>
      </div>
    </div>
  )
})

export default Progress
